import { ErrorMessage, useField } from "formik"
import styles from './MyDatePicker.module.css'
import gregorian_es from "../../../const/gregorian_es"
import DatePicker from "react-multi-date-picker";


export const MyDatePicker = ({ label, mode = "vertical", ...props }) => {

  const [field] = useField(props)

  return <>
    {
      mode === "horizontal" &&
      <div className="mb-3 row">
        <label className='col-form-label col-4' htmlFor={props.id || props.name} >{label}</label>
        <div className="col-8">
          <DatePicker
            className={`form-control fc-datepicker ${styles.select}`}
            multiple={false}
            numberOfMonths={1}
            locale={gregorian_es}
            format="DD/MM/YYYY"
            {...field} {...props}
          />
          <ErrorMessage name={props.name} component="span" className={styles.errorMessage} />
        </div>
      </div>
    }
    {
      mode === "vertical" &&
      <div className="mb-3">
        <label className='form-label' htmlFor={props.id || props.name} >{label}</label>
        <DatePicker
          className="form-control fc-datepicker"
          multiple={false}
          numberOfMonths={1}
          locale={gregorian_es}
          format="DD/MM/YYYY"
          {...field} {...props}
        />
        <ErrorMessage name={props.name} component="span" className={styles.errorMessage} />
      </div>
    }
  </>
}
